import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-generation',
  imports: [CommonModule],
  templateUrl: './loading-generation.component.html',
  styleUrl: './loading-generation.component.css'
})
export class LoadingGenerationComponent implements OnInit{
processMessage: string = ''
@Input() widgetName:string=""

ngOnInit(): void {
  this.processMessage = 'Raccogliendo tutti i dati per la creazione del report...';

}

endingMessage(){
  this.processMessage= 'Esportazione in corso...'
}

}
